const locale = 'pt-BR';
const config = {
  precision: 10, // total number of digits stored: 100.00 would be 5
  scale: 2, // number of decimals to store: 100.00 would be 2
};

export const toMask = (value: string | number, prefix: string = 'R$') => {
  let number = Number(
    value
      .toLocaleString(locale, { minimumFractionDigits: config.scale })
      .replace(/[^0-9]/g, '')
  );
  if (Number.isNaN(number)) {
    number = 0;
  }

  const factorOfTen = 10 ** config.scale;

  if (String(number).length > config.precision) {
    number = Math.trunc(number / 10);
  }

  const currency = prefix ? `${prefix} ` : '';
  return `${currency}${(number / factorOfTen).toLocaleString(locale, {
    minimumFractionDigits: config.scale,
  })}`;
};

// baseado no locale "pt-BR"
export const toNumber = (value: string) => {
  return Number(
    value
      .replace(/\./g, '')
      .replace(',', '.')
      .replace(/[^0-9.]/g, '')
  );
};
